import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { downloadTempData } from '@asset-solutions/customer-portal/orders/utils';
import { EquipmentService } from '@asset-solutions/customer-portal/shared/data-access';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { OrderSummaryVM } from '../order-summary-vm';

@Component({
  selector: 'orders-temp-range-column',
  imports: [FontAwesomeModule, MatTooltip],
  template: `
    <div class="text-center" [class.text-danger]="order.hasTempDeviation">
      <div class="mb-1">{{ order.trailer.tempMin }} to {{ order.trailer.tempMax }}</div>
      <button
        class="download-button"
        matTooltip="Download temp data"
        matTooltipPosition="right"
        (click)="download($event)"
      >
        <fa-icon [icon]="downloadIcon" />
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TempRangeComponent {
  @Input() order!: OrderSummaryVM;

  private readonly equipmentService = inject(EquipmentService);

  protected downloadIcon = faDownload;

  protected download($event: MouseEvent): void {
    const startDate = this.order.origin?.scheduledETA ? new Date(this.order.origin?.scheduledETA) : new Date();
    const endDate = this.order.nextStop?.scheduledETA ? new Date(this.order.nextStop.scheduledETA) : undefined;
    this.equipmentService.getSensorData(this.order.trailer.trailerId, startDate, endDate).subscribe((response) => {
      downloadTempData(response, this.order.trailer.trailerId);
    });
    $event.stopPropagation();
  }
}
